module.exports = __webpack_public_path__ + "img/survey-4.bc1dc976.png";